// Shared localStorage key prefix for the per-user shop-scope selection. Lives in
// its own module so the writer (LocationScope) and the sign-out purge (auth)
// share one source of truth without a circular import (LocationScope imports
// useAuth, so auth must not import LocationScope).
export const SELECTED_LOCATION_KEY_PREFIX = 'fw:selectedLocation:';
